export const truncatePropertyName = (propertyName: string | undefined, length: number = 30): string | undefined => {
  if(!propertyName) return undefined
  const trimmed = propertyName.substring(0, length)
  return trimmed.length !== propertyName.length ? trimmed + "..." : trimmed;
}